import React from 'react';
import Component from '@vfuk/core-image';
const Image = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Image;
